// Opens the demo menu from anywhere (logo taps, keyboard shortcut).
type L = () => void;
const ls = new Set<L>();
export const openDemoMenu = () => ls.forEach((l) => l());
export const onOpenDemoMenu = (l: L) => { ls.add(l); return () => { ls.delete(l); }; };
